import { useEffect } from 'react';
import { useAuth } from '../shared/useAuth.js';

export function Providers({ children }) {
  const bootstrap = useAuth((s) => s.bootstrap);

  useEffect(() => {
    bootstrap();
  }, [bootstrap]);

  return <>{children}</>;
}
